import { Logger } from '../../../logger/Logger';
import { configActions } from '../../../store/slices/config/slice';
import type { GameCommunicationMessageType } from '../types';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

interface SwitchMessage extends GameCommunicationMessageType {
  httpAddress?: unknown;
  wsAddress?: unknown;
}

export class CoreSwitchGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.Switch;
  public delay = 0;

  public process(message: SwitchMessage): void {
    if (message && typeof message.httpAddress === 'string' && typeof message.wsAddress === 'string') {
      Logger.logEvent('serverSwitchRequested');
      this.store.dispatch(
        configActions.setGameServer({
          httpAddress: message.httpAddress,
          wsAddress: message.wsAddress,
        })
      );
    }
  }
}
